import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const GET_BUSINESS_INFO = gql`
  query BusinessEntityInfo($businessEntityUuid: UUID!) {
    businessEntity(businessEntityUuid: $businessEntityUuid) {
      name
      planType
      nameInitials
      formationDate
    }
  }
`;

function useBusinessEntityInfo() {
  const { businessEntityUuid } = useBusinessEntity();
  const { loading, data, error } = useQuery(GET_BUSINESS_INFO, {
    noThrow: true,
    variables: {
      businessEntityUuid
    }
  });

  useError(error);

  return {
    loading,
    businessEntityInfo: data?.businessEntity
  };
}

export { useBusinessEntityInfo };
